import { Link } from 'react-router-dom';
import styles from './NotFoundPage.module.css';

export const NotFoundPage = () => (
  <div className={styles.wrapper}>
    <div className={styles.card}>
      <span className={styles.badge}>404</span>
      <h1>We lost that trail</h1>
      <p>
        The page you are looking for might have been removed, renamed, or is temporarily
        unavailable.
      </p>
      <Link to="/" className={styles.cta}>
        Back to Discover
      </Link>
    </div>
  </div>
);
